import { DeleteOutlined } from '@ant-design/icons';
import { Upload, Modal, Typography } from 'antd';
import React, { useCallback } from 'react';

import { PREFIX } from '@app/constants';
import { ACCEPTED_FILE_TYPES } from '@app/pages/Warehouses/Products/components/AddProduct/components/ProductImagesUploader/data';
import { useProductImagesUploader } from '@app/pages/Warehouses/Products/components/AddProduct/components/ProductImagesUploader/hooks';
import type {
  ProductImagesUploaderProps,
  ProductImageFile,
} from '@app/pages/Warehouses/Products/components/AddProduct/components/ProductImagesUploader/types';
import '@app/pages/Warehouses/Products/components/AddProduct/components/ProductImagesUploader/styles/ProductImagesUploader.scss';

const { Text } = Typography;

export const ProductImagesUploader = ({
  fileList,
  setFileList,
}: ProductImagesUploaderProps) => {
  const {
    handlePreview,
    handleDragStart,
    handleDrop,
    handleDragEnd,
    previewVisible,
    handleCancel,
    previewImage,
    isSorting,
    preventUploadDrop,
  } = useProductImagesUploader({ fileList, setFileList });

  const handleRemove = useCallback(
    (uid: string) => {
      setFileList((prev) => prev.filter((file) => file.uid !== uid));
    },
    [setFileList]
  );

  const handleUploadChange = useCallback(
    ({ fileList: nextUploadFileList }: { fileList: ProductImageFile[] }) => {
      if (isSorting) return;

      const newFiles: ProductImageFile[] = nextUploadFileList.map((file) => ({
        ...file,
        url: file.originFileObj
          ? URL.createObjectURL(file.originFileObj)
          : file.url,
      }));

      setFileList((prev) => [...prev, ...newFiles]);
    },
    [isSorting, setFileList]
  );

  return (
    <div className={`${PREFIX}product-images-uploader`}>
      <Text strong>Фотографии товара</Text>
      <br />
      <Text type="secondary">
        Порядок отображения нескольких фотографий можно менять перетаскиванием.
      </Text>

      <div className="images-wrapper">
        {fileList.map((file, index) => (
          <div
            key={file.uid}
            draggable
            onClick={() => handlePreview(file)}
            onDragStart={() => handleDragStart(index)}
            onDragEnd={handleDragEnd}
            onDragOver={(e) => e.preventDefault()}
            onDrop={() => handleDrop(index)}
            className="image-item"
          >
            <img
              src={file.thumbUrl || file.url}
              alt="preview"
              className="image-preview"
            />

            <button
              type="button"
              className="delete-btn"
              onClick={(e) => {
                e.stopPropagation();
                handleRemove(file.uid);
              }}
            >
              <DeleteOutlined />
            </button>
          </div>
        ))}

        <div
          onDragEnter={preventUploadDrop}
          onDragOver={preventUploadDrop}
          onDrop={preventUploadDrop}
        >
          <Upload
            listType="picture-card"
            fileList={[]}
            beforeUpload={() => false}
            onChange={handleUploadChange}
            showUploadList={false}
            accept={ACCEPTED_FILE_TYPES}
          >
            <div className="upload-placeholder">
              <Text>Добавить изображение</Text>
            </div>
          </Upload>
        </div>
      </div>

      <Modal open={previewVisible} footer={null} onCancel={handleCancel}>
        <img alt="preview" className="full-size-image" src={previewImage} />
      </Modal>
    </div>
  );
};
